@if (outlookIndicator?.outlookConfig) {
  <svg-icon
    [key]="outlookIndicator?.outlookConfig?.icon ?? 'unknown'"
  ></svg-icon>
}
@if (outlookIndicator?.count !== undefined) {
  <span>
    {{outlookIndicator?.count === 0 ? '-' : outlookIndicator?.count}}
  </span>
} @else {
  @if (!outlookIndicator?.aggregate) {
    {{outlookIndicator?.outlook}}
  } @else {
    @if (!(outlookIndicator?.stacked)) {
      {{outlookIndicator?.aggregate}}
    } @else {
      <div class="stacked">
        <span class="x-small-text">At least one</span>
        <span>{{outlookIndicator?.outlook}}</span>
        <span class="x-small-text">Indicator</span>
      </div>
    }
  }
}


